// domain/entities/ReconciliationTask.js
import { TASK_STATUSES } from '../constants/reconciliation';

// eslint-disable-next-line import/prefer-default-export
export function createReconciliationTask(sessionActivity) {
  return {
    sessionActivity,
    availableAppointments: [],
    selectedAppointmentId: null,
    taskStatus: TASK_STATUSES.PENDING,
    errorMessage: null,

    markProcessing() { this.taskStatus = TASK_STATUSES.PROCESSING; },
    markLoaded(availableAppointments) {
      if (sessionActivity.appointment) {
        this.taskStatus = TASK_STATUSES.ALREADY_LINKED;
        this.availableAppointments = [];
        return;
      }
      if (availableAppointments.length === 0) {
        this.taskStatus = TASK_STATUSES.NO_MATCH;
        this.availableAppointments = [];
        return;
      }

      this.taskStatus = TASK_STATUSES.LOADED;
      this.availableAppointments = availableAppointments;
    },
    markLinked() { this.taskStatus = TASK_STATUSES.LINKED; },
    markFailed(error) { this.taskStatus = TASK_STATUSES.FAILED; this.errorMessage = error; },
    markCancelled() { this.taskStatus = TASK_STATUSES.CANCELLED; },
    isPending() { return this.taskStatus === TASK_STATUSES.PENDING; },
    isLoaded() { return this.taskStatus === TASK_STATUSES.LOADED; },
    isConfirmed() { return this.taskStatus === TASK_STATUSES.CONFIRMED; },
    isLinked() { return this.taskStatus === TASK_STATUSES.LINKED; },
    isFailed() { return this.taskStatus === TASK_STATUSES.FAILED; },
    isCancelled() { return this.taskStatus === TASK_STATUSES.CANCELLED; },
    isActionable() {
      return this.taskStatus === TASK_STATUSES.LOADED || this.taskStatus === TASK_STATUSES.CONFIRMED;
    },

    /**
     * Returns the start-time difference in ms if the appointment falls within the
     * given tolerances, or null if it is out of range. Lower score = better match.
     */
    scoreAppointment(appt, startToleranceSeconds, endToleranceSeconds) {
      const activityStart = this.sessionActivity.startTimestamp.toDate().getTime();
      const activityEnd = this.sessionActivity.endTimestamp.toDate().getTime();
      const apptStart = appt.scheduledStartTimestamp.toDate().getTime();
      const apptEnd = apptStart + appt.duration * 1000;
      const normalizeToMinute = (timestamp) => Math.floor(timestamp / 60000) * 60000;
      const startDiff = startToleranceSeconds === 0
        ? Math.abs(normalizeToMinute(activityStart) - normalizeToMinute(apptStart))
        : Math.abs(activityStart - apptStart);
      const endDiff = endToleranceSeconds === 0
        ? Math.abs(normalizeToMinute(activityEnd) - normalizeToMinute(apptEnd))
        : Math.abs(activityEnd - apptEnd);
      const withinTolerance = startDiff <= startToleranceSeconds * 1000
        && endDiff <= endToleranceSeconds * 1000;
      return withinTolerance ? startDiff : null;
    },

    linkAppointment(appointmentId) {
      if (this.taskStatus !== TASK_STATUSES.LOADED) {
        return; // Only allow linking if the task is in the LOADED state
      }
      const isCandidate = this.availableAppointments.some(({ id }) => id === appointmentId);
      if (!isCandidate) {
        return;
      }
      this.selectedAppointmentId = appointmentId;
      this.taskStatus = TASK_STATUSES.CONFIRMED;
    },
    unlinkAppointment() {
      if (this.taskStatus !== TASK_STATUSES.CONFIRMED) {
        return; // Only allow unlinking if the task is in the CONFIRMED state
      }
      this.selectedAppointmentId = null;
      this.taskStatus = TASK_STATUSES.LOADED;
    },

  };
}
